module.exports = __webpack_public_path__ + "static/media/credit-card_jcb.1f1a8c50.svg";